module.exports = __webpack_public_path__ + "img/s_4.2a89eed9.png";